import { render, staticRenderFns } from "./commissionRecord.vue?vue&type=template&id=1bf680f1&scoped=true&"
import script from "./commissionRecord.vue?vue&type=script&lang=js&"
export * from "./commissionRecord.vue?vue&type=script&lang=js&"
import style0 from "./commissionRecord.vue?vue&type=style&index=0&id=1bf680f1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf680f1",
  null
  
)

export default component.exports